import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import { Card } from 'antd';
import { DetailPageSkeleton } from '../SkeletonLoaders';
import WorkPageHeader from './WorkPageHeader';
import EntityBreadcrumb from '../common/EntityBreadcrumb';

/**
 * قالب صفحات جزئیات ماژول کار
 */
const WorkDetailPage = ({
  title,
  subtitle,
  icon,
  backPath,
  onBack,
  headerExtra,
  children,
  loading = false,
  breadcrumbTrail = null,
  onBreadcrumbNavigate = null,
}) => (
  <MainLayout>
    <div style={{ fontFamily: 'CustomFont' }}>
      <Card className="shadow-xl border-0 work-page-card" bodyStyle={{ padding: 0 }}>
        {breadcrumbTrail?.length ? (
          <EntityBreadcrumb trail={breadcrumbTrail} onNavigate={onBreadcrumbNavigate} />
        ) : null}
        <WorkPageHeader
          title={title}
          subtitle={subtitle}
          icon={icon}
          showBack
          backPath={backPath}
          onBack={onBack}
          headerExtra={headerExtra}
        />
        <div className="p-6 work-page-body rounded-b-xl" style={{ fontFamily: 'CustomFont' }}>
          {loading ? <DetailPageSkeleton /> : children}
        </div>
      </Card>
    </div>
  </MainLayout>
);

export default WorkDetailPage;
